import { RootState } from 'handlers';

export const getSelectedTheme = (state: RootState) => state.theme;
